/**
 * Map a free-text subject string to a TeeBee subject theme CSS class.
 * Returns "" if no theme matches — content renders with default styles.
 */
export function subjectThemeClass(subject) {
  if (!subject) return "";
  const s = subject.toLowerCase();
  if (/(math|maths|mathematics|algebra|geometry|calculus|trigonometry)/.test(s)) return "tb-subject-math";
  if (/(science|physics|chemistry|biology|environment|evs|earth)/.test(s)) return "tb-subject-science";
  if (/(history|social|civics|geography|polity|economic\s*history)/.test(s)) return "tb-subject-history";
  if (/(english|language|hindi|sanskrit|french|german|spanish|literature|grammar)/.test(s)) return "tb-subject-language";
  if (/(commerce|business|accounts|account|economics|finance|marketing)/.test(s)) return "tb-subject-commerce";
  if (/(university|undergraduate|postgraduate|college|faculty|research)/.test(s)) return "tb-subject-university";
  if (/(preschool|kindergarten|kg|nursery|playgroup|early\s*years|toddler)/.test(s)) return "tb-subject-preschool";
  return "";
}
